import { render, staticRenderFns } from "./BlwButton.vue?vue&type=template&id=6399dfc6&"
import script from "./BlwButton.vue?vue&type=script&lang=js&"
export * from "./BlwButton.vue?vue&type=script&lang=js&"
import style0 from "./BlwButton.vue?vue&type=style&index=0&id=6399dfc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports